import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class VerticalNavCollapseOverrideService {
  private readonly forceCollapsedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public readonly forceCollapsed$: Observable<boolean> = this.forceCollapsedSubject.asObservable();

  private readonly navExpandedSubject: Subject<void> = new Subject<void>();
  public readonly navExpanded$: Observable<void> = this.navExpandedSubject.asObservable();

  public setForceCollapsed(forceCollapsed: boolean): void {
    this.forceCollapsedSubject.next(forceCollapsed);
  }

  public notifyNavExpanded(): void {
    this.navExpandedSubject.next();
  }
}
